import { createBrowserRouter } from "react-router";
import { PublicHomePage } from "./pages/PublicHomePage";
import { FinalLoginPage } from "./pages/FinalLoginPage";
import { AdminPage } from "./pages/AdminPage";
import { AdminLoginPage } from "./pages/AdminLoginPage";
import { SecureAccessPage } from "./pages/SecureAccessPage";
import { NDAPage } from "./pages/NDAPage";
import { GroupOverviewPage } from "./pages/GroupOverviewPage";
import { InfrastructurePage } from "./pages/InfrastructurePage";
import { PlatformEcosystemPage } from "./pages/PlatformEcosystemPage";
import { LicensedSolutionsPage } from "./pages/LicensedSolutionsPage";
import { OperatingModelPage } from "./pages/OperatingModelPage";
import { CommercialModelPage } from "./pages/CommercialModelPage";
import { SecurityCompliancePage } from "./pages/SecurityCompliancePage";
import { PartnerEcosystemPage } from "./pages/PartnerEcosystemPage";
import { ManagementContactPage } from "./pages/ManagementContactPage";
import { AccessPage } from "./pages/AccessPage";
import { AdminNDAViewPage } from "./pages/AdminNDAViewPage";
import ISOPage from "./pages/ISOPage";
import { ClientNDAViewPage } from "./pages/ClientNDAViewPage";
import { TermsPage } from "./pages/TermsPage";
import { PrivacyPage } from "./pages/PrivacyPage";
import { POPIAPage } from "./pages/POPIAPage";
import { PortalGuard } from "./components/PortalGuard";
import { AdminGuard } from "./components/AdminGuard";

function ErrorBoundary() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-4xl text-gray-900 mb-4">Page Not Found</h1>
        <p className="text-gray-600 mb-8">The page you're looking for doesn't exist.</p>
        <a href="/" className="bg-blue-600 text-white px-6 py-3 rounded hover:bg-blue-700 transition-colors inline-block">
          Return to Home
        </a>
      </div>
    </div>
  );
}

export const router = createBrowserRouter([
  // ─── Public ────────────────────────────────────────────────────────────────
  { path: "/",              Component: PublicHomePage },
  { path: "/login",         Component: FinalLoginPage },
  { path: "/confidential",  Component: SecureAccessPage },
  { path: "/nda",           Component: NDAPage },
  { path: "/access/:token", Component: AccessPage },
  { path: "/nda-record/:token", Component: ClientNDAViewPage },
  { path: "/admin-login",   Component: AdminLoginPage },
  { path: "/terms",         Component: TermsPage },
  { path: "/privacy",       Component: PrivacyPage },
  { path: "/compliance",    Component: POPIAPage },

  // ─── Portal (token session required) ──────────────────────────────────────
  {
    element: <PortalGuard />,
    children: [
      { path: "/overview",           Component: GroupOverviewPage },
      { path: "/welcome",            Component: GroupOverviewPage },
      { path: "/group-structure",    Component: GroupOverviewPage },
      { path: "/infrastructure",     Component: InfrastructurePage },
      { path: "/platforms",          Component: PlatformEcosystemPage },
      { path: "/licensed-solutions", Component: LicensedSolutionsPage },
      { path: "/operating-model",    Component: OperatingModelPage },
      { path: "/partner-ecosystem",  Component: PartnerEcosystemPage },
      { path: "/commercial-model",   Component: CommercialModelPage },
      { path: "/security-compliance", Component: SecurityCompliancePage },
      { path: "/management-contact", Component: ManagementContactPage },
    ],
  },

  // ─── Admin (JWT cookie required) ──────────────────────────────────────────
  {
    element: <AdminGuard />,
    children: [
      { path: "/admin",               Component: AdminPage },
      { path: "/admin/nda-view/:id",  Component: AdminNDAViewPage },
      { path: "/admin/iso",           Component: ISOPage },
    ],
  },

  // ─── Fallback ──────────────────────────────────────────────────────────────
  { path: "*", Component: ErrorBoundary },
]);
